import { LOCALE_LABELS, SUPPORTED_LOCALES, useLocale } from "./i18n";

export function LocaleSwitcher() {
  const { locale, setLocale } = useLocale();
  return (
    <label className="locale-switcher">
      <select
        value={locale}
        onChange={(e) => setLocale(e.target.value as typeof locale)}
        aria-label="Language"
      >
        {SUPPORTED_LOCALES.map((code) => (
          <option key={code} value={code}>
            {LOCALE_LABELS[code]}
          </option>
        ))}
      </select>
    </label>
  );
}
